import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { groupsForScope, mergeFieldOptions } from '../../util/trialTagFields';
import { suggestionsFor } from '../../util/trialTagMemory';
import '../../../dist/assets/stylesheets/css/recordPatient.css';

/*
 * Menus are portaled to the body: these fields live inside AnimateHeight
 * containers, which clip overflow while animating.
 */
const selectStyles = {
    control: (base) => ({ ...base, minHeight: 34, borderColor: '#ddd', fontSize: '0.95rem' }),
    dropdownIndicator: (base) => ({ ...base, padding: 4 }),
    clearIndicator: (base) => ({ ...base, padding: 4 }),
    indicatorSeparator: () => ({ display: 'none' }),
    valueContainer: (base) => ({ ...base, padding: '0 6px' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

function toOption(value) {
    return { label: value, value };
}

function TrialTagFields(props) {
    const { scope, values, onChange, idPrefix, disabled, suggestions } = props;
    const current = values || {};

    const renderInput = (field) => {
        const inputId = `${idPrefix}-${field.key}`;
        const value = current[field.key];

        if (field.type === 'text') {
            return (
                <input
                    id={inputId}
                    className="trial-tag-field__input"
                    type="text"
                    value={value || ''}
                    disabled={disabled}
                    onChange={(e) => onChange(field.key, e.target.value)}
                />
            );
        }

        const isMulti = field.type === 'tags';
        return (
            <CreatableSelect
                inputId={inputId}
                classNamePrefix="trial-tag-select"
                className="trial-tag-field__select"
                isMulti={isMulti}
                isClearable
                isDisabled={disabled}
                placeholder={isMulti ? 'Add tags…' : 'Type a value…'}
                /* Values this account entered before, plus any presets the field ships with. */
                options={mergeFieldOptions(field.options, suggestionsFor(suggestions, field.key)).map(toOption)}
                /* Keep the current value in the menu so a single prior term is still visible. */
                hideSelectedOptions={false}
                noOptionsMessage={() => 'Type to add a value'}
                styles={selectStyles}
                menuPortalTarget={typeof document === 'undefined' ? null : document.body}
                menuPosition="fixed"
                /* Open downward so the menu does not cover the session tag chips above. */
                menuPlacement="bottom"
                value={isMulti ? (value || []).map(toOption) : (value ? toOption(value) : null)}
                onChange={(selection) => {
                    if (isMulti) {
                        onChange(field.key, selection ? selection.map((option) => option.value) : []);
                        return;
                    }
                    onChange(field.key, selection ? selection.value : '');
                }}
            />
        );
    };

    return (
        <div className="trial-tag-fields">
            {groupsForScope(scope).map((group) => (
                <div className="trial-tag-group" key={group.group}>
                    <span className="trial-tag-group__title">{group.group}</span>
                    <div className="trial-tag-group__fields">
                        {group.fields.map((field) => (
                            <div
                                className={`trial-tag-field trial-tag-field--${field.type}`}
                                key={field.key}
                            >
                                <label className="trial-tag-field__label" htmlFor={`${idPrefix}-${field.key}`}>
                                    {field.label}
                                </label>
                                {renderInput(field)}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default TrialTagFields;
